module.exports = __webpack_public_path__ + "img/welcome.abb7c55c.svg";